import { PlusOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, message, Typography } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAnnouncements } from "../../../../hooks/useAnnouncement";
import { AnnouncementFilter } from "../components/AnnouncementFilter";
import { AnnouncementList } from "../components/AnnouncementList";

const { Title } = Typography;

export function AnnouncementsPage() {
  const [filter, setFilter] = useState({ page: 1, limit: 10 });
  const { data, loading, total, remove, togglePin } = useAnnouncements(filter);
  const navigate = useNavigate();

  const handleDelete = async (id) => {
    try {
      await remove.mutateAsync(id);
      message.success("Xóa thông báo thành công");
    } catch (error) {
      console.error(error);
      message.error(`${error || "Lỗi hệ thống."}`);
    }
  };

  const handleTogglePin = async (record) => {
    try {
      await togglePin.mutateAsync(record._id);
      message.success(
        record.isPinned
          ? "Bỏ ghim thông báo thành công"
          : "Ghim thông báo thành công",
      );
    } catch (error) {
      console.error(error);
      message.error(`${error || "Lỗi hệ thống."}`);
    }
  };

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
  };

  return (
    <div style={{ padding: 24 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Breadcrumb
            items={[{ title: "Bảng điều khiển" }, { title: "Thông báo" }]}
          />
          <Title level={3} style={{ margin: 0 }}>
            Quản lý thông báo
          </Title>
        </div>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate("/bang-dieu-khien/thong-bao/create")}
        >
          Thêm thông báo
        </Button>
      </div>

      <div style={{ padding: "24px 0" }}>
        <AnnouncementFilter
          filter={filter}
          onFilterChange={handleFilterChange}
        />
      </div>

      <div>
        <AnnouncementList
          data={data}
          total={total}
          loading={loading}
          filter={filter}
          onFilterChange={handleFilterChange}
          onEdit={(item) => navigate(`/bang-dieu-khien/thong-bao/${item._id}`)}
          onDelete={handleDelete}
          onTogglePin={handleTogglePin}
        />
      </div>
    </div>
  );
}
